import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import Block from './Block'
import logo from '../assets/images/logo/swarmia-logo-on-white.svg'
import { StaticImage } from 'gatsby-plugin-image'

const Footer = () => (
  <footer>
    <Block>
      <div className="footer_menu-grid">
        <div className="footer_menu-grid_s">
          <div className="footer_menu-logo">
            <Link to="/">
              <Logo />
            </Link>
          </div>
          <div className="address">
            Lapinlahdenkatu 16,
            <br />
            00180 Helsinki, Finland
          </div>
          <div className="address">
            169 Madison Ave, Suite 15682
            <br />
            New York, NY 10016
          </div>
          <div className="social">
            <a href="https://x.com/swarmiahq" target="_blank" rel="noreferrer">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.7142 10.6226L20.4162 3H18.8286L13.0068 9.61726L8.3604 3H3L10.0278 13.0074L3 20.9999H4.5876L10.7316 14.0104L15.6396 20.9999H21M5.1606 4.17142H7.5996L18.8274 19.8861H16.3878"
                  fill="currentColor"
                />
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/company/swarmia/about/"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.25 0.75H18.75C21.2353 0.75 23.25 2.76472 23.25 5.25V18.75C23.25 21.2353 21.2353 23.25 18.75 23.25H5.25C2.76472 23.25 0.75 21.2353 0.75 18.75V5.25C0.75 2.76472 2.76472 0.75 5.25 0.75ZM9.14754 17.25V9.41574H6.93443V17.25H9.14754ZM8.04098 8.51266C7.32836 8.51266 6.75 7.95002 6.75 7.25633C6.75 6.56264 7.32836 6 8.04098 6C8.75361 6 9.33197 6.56264 9.33197 7.25633C9.33197 7.95002 8.75434 8.51266 8.04098 8.51266ZM15.7869 17.25H18V12.4362C18 8.69499 13.8659 8.83102 12.8361 10.6728V9.41574H10.623V17.25H12.8361V13.2588C12.8361 11.0417 15.7869 10.8601 15.7869 13.2588V17.25Z"
                  fill="currentColor"
                />
              </svg>
            </a>
          </div>
        </div>
        <div className="footer_menu-grid_columns">
          <div className="footer_menu-grid_column">
            <h5>Product</h5>
            <ul>
              <li>
                <Link to="/changelog/">Changelog</Link>
              </li>
              <li>
                <Link to="/product/">Overview</Link>
              </li>
              <li>
                <Link to="/product/business-outcomes/">
                  Business&nbsp;outcomes
                </Link>
              </li>
              <li>
                <Link to="/product/developer-productivity/">
                  Developer&nbsp;productivity
                </Link>
              </li>
              <li>
                <Link to="/product/developer-experience/">
                  Developer&nbsp;experience
                </Link>
              </li>
              <li />
              <li />
            </ul>
          </div>
          <div className="footer_menu-grid_column">
            <h5>Learn</h5>
            <ul>
              <li>
                <Link to="/blog/">Blog</Link>
              </li>
              <li>
                <Link to="/podcast/">Podcast</Link>
              </li>
              <li>
                <Link to="/benchmarks/">Benchmarks</Link>
              </li>
              <li>
                <Link to="/build/">Book: Build</Link>
              </li>
            </ul>
          </div>
          <div className="footer_menu-grid_column">
            <h5>Company</h5>
            <ul>
              <li>
                <Link to="/pricing/">Pricing</Link>
              </li>
              <li>
                <Link to="/customers/">Customers</Link>
              </li>
              <li>
                <a
                  href="https://help.swarmia.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Help center ↗
                </a>
              </li>
              <li>
                <Link to="/careers">Careers</Link>
              </li>
              <li>
                <Link to="/about-us/">About us</Link>
              </li>
            </ul>
          </div>
          <div className="footer_menu-grid_column">
            <h5>SOC 2 Type 2 compliant</h5>
            <ul>
              <li>
                <a href="https://www.swarmia.com/blog/soc-2-type-2/">
                  <StaticImage
                    src="../assets/images/badges/soc-2-icon.png"
                    alt="Swarmia is SOC 2 Type 2 compliant"
                    width={64}
                    height={64}
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer_bottom">
        <span className="footer_bottom-links">
          <Link to="/terms/">Terms&nbsp;of&nbsp;service</Link>
          <Link to="/privacy/">Privacy policy</Link>
          <Link to="/security/">Security</Link>
          <a href="https://status.swarmia.com/">Status</a>
          <a href="#" className="ch2-open-settings-btn">
            Manage&nbsp;cookies
          </a>
        </span>
        <span className="footer_bottom-copyright">
          <a href="mailto:hello@swarmia.com">hello@swarmia.com</a>
          <br />© Swarmia {new Date().getFullYear()}
        </span>
      </div>
    </Block>
  </footer>
)

const Logo = styled.div`
  height: 80px;
  width: 64px;
  background-image: url(${logo});
  background-size: 100%;
  background-repeat: no-repeat;
  display: inline-block;
`

export default Footer
